import { render, staticRenderFns } from "./AdministratorSecurity.vue?vue&type=template&id=36d2cfa9&"
import script from "./AdministratorSecurity.vue?vue&type=script&lang=js&"
export * from "./AdministratorSecurity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports